import { LocalPlay } from "./pages/LocalPlay.js";
import { Solo } from "./pages/Solo.js";
import { Landing } from "./pages/Landing.js";
import { AgeGate } from "./pages/AgeGate.js";
import { FriendInvites } from "./pages/FriendInvites.js";
import { RoomPage } from "./pages/Room.js";
import { path } from "./router.js";
import { SettingsSheet } from "./settings/SettingsSheet.js";

const ROOM = /^\/r\/([A-Za-z0-9_-]{1,64})$/;

/**
 * The app's routes: the start at `/new` (making a room; `/` is the website's home, served by the
 * router Worker), a room (`/r/:id`, an invite link adds `#secret`), solo play (`/solo`, ADR 0020),
 * and the sandbox. All but the sandbox first ask "16 or older?" once per browser (ADR 0025).
 */
export function App() {
  return (
    <>
      <Routes />
      <SettingsSheet />
    </>
  );
}

function Routes() {
  const current = path.value;
  if (current.startsWith("/play/local")) return <LocalPlay />;
  // Everything but the sandbox asks "16 or older?" once first (ADR 0025).
  if (current === "/solo")
    return (
      <AgeGate>
        <Solo />
      </AgeGate>
    );
  const roomId = ROOM.exec(current)?.[1];
  if (roomId !== undefined)
    return (
      <AgeGate>
        <FriendInvites currentRoom={roomId} />
        {/* Keyed: moving to another room (#616) starts its page afresh. */}
        <RoomPage key={roomId} roomId={roomId} />
      </AgeGate>
    );
  return (
    <AgeGate>
      <FriendInvites />
      <Landing />
    </AgeGate>
  );
}
